
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/couponCampaignretailer",
      function () {
        return require("private-next-pages/couponCampaignretailer.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/couponCampaignretailer"])
      });
    }
  